<template>
  <div>
    <!-- 适用于所有对话框的弹出类型 -->
    <el-dialog
      :title="dialogData.title"
      :visible.sync="dialogData.dialogVisible"
      :width="dialogData.width ? dialogData.width : '60%'"
      :before-close="handleClose"
    >

      <div
        v-if="
          dialogData.data &&
          this.dialogData.level !== '2' &&
          dialogData.edit !== true
        "
      >
        <div
          class="diaStyle"
          v-if="
            dialogData.data.details &&
            dialogData.data.details.resource_type !== 4
          "
        >
          <div class="top">
            <div class="imges">
              <img
                :src="
                  dialogData.data.details.ico_file_bucket +
                  dialogData.data.details.thumbnail
                "
                alt=""
                :onerror="defaultImg"
              />
            </div>
            <div class="title" >
              <h2>{{ dialogData.data.details.name }}</h2>
              <span v-if="dialogData.data.category_name.belong_site"
                >所属位置:<em>{{
                  dialogData.data.category_name.belong_site[0].site
                }}</em></span
              >
            </div>
          </div>
          <div class="introduce">
            <h3>简介:</h3>
            <p>{{ dialogData.data.details.introduce }}</p>
          </div>
          <div class="content" v-if="!isIframe && !isWord">
            <div v-if="mp4 || mp3">
              <video
              v-if="mp4"
                :src="
                  dialogData.data.details.file_bucket +
                  dialogData.data.details.file_origin
                "
                controls

              />
              <audio
              v-if="mp3"
                :src="
                  dialogData.data.details.file_bucket +
                  dialogData.data.details.file_origin
                "
                controls

              />
            </div>

            <img
              v-else
              :src="
                dialogData.data.details.file_bucket +
                dialogData.data.details.file_origin
              "
              controls
              :onerror="defaultImg"
            />
          </div>
          <div class="iframe" style="width:100%;height:50vh;overflow:auto" v-if="isIframe">
            <iframe style="width: 100%; height: 100vh;overflow:auto" :src="iframUrl"></iframe>
          </div>
          <div v-if="isWord" style="width:100%;height:500px">
              <div id="previewjiaoben"></div>
          </div>
          <div
            class="introduce"
            v-if="
              dialogData.data.details.resource_type == '7' ||
              dialogData.data.details.resource_type == '8' ||
              dialogData.data.details.resource_type == '9'
            "
          >
            <h3>链接:</h3>
            <p>{{ dialogData.data.details.link }}</p>
          </div>
        </div>
        <div v-else>
          <div class="introduce">
            <h3>题干:</h3>
            <p>{{ dialogData.data.details.name }}</p>
          </div>
          <div class="introduce">
            <h3>选项:</h3>
            <div>
              <p
                v-for="item in dialogData.data.details.options"
                :key="item.number"
              >
                <span>{{ item.zmb }}.</span>{{ item.option }}
              </p>
            </div>
          </div>
          <div class="introduce">
            <h3>答案:</h3>
            <p>{{ dialogData.data.details.answer }}</p>
          </div>
          <div class="introduce">
            <h3>解析:</h3>
            <p>{{ dialogData.data.details.introduce }}</p>
          </div>
          <div class="introduce">
            <h3>难易程度:</h3>
            <p>
              {{
                dialogData.data.details.question_difficulty == "1"
                  ? "难"
                  : dialogData.data.details.question_difficulty == "2"
                  ? "中"
                  : "易"
              }}
            </p>
          </div>
          <div class="introduce">
            <h3>所属位置:</h3>
            <div v-if="dialogData.data.category_name.belong_site">
              <p
                v-for="item in dialogData.data.category_name.belong_site"
                :key="item.id"
              >
                {{ item.site }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else-if="
          (dialogData.data && dialogData.title == '查看') ||
          (dialogData.data && dialogData.title == '审核')
        "
      >
        <div class="introduce">
          <h3>课程名称:</h3>
          <p>{{ dialogData.data.details.name }}</p>
        </div>
        <div class="introduce">
          <h3>课程简介:</h3>
          <p>{{ dialogData.data.details.introduce }}</p>
        </div>
        <div class="introduce">
          <h3>课程所属专业:</h3>
          <p>{{ dialogData.data.details.major }}</p>
        </div>
        <div class="introduce">
          <div style="display: flex;flex-wrap: wrap;justify-content: space-between;width:100%">
          <div class="kc">
            <h3>封面课程:</h3>
            <img
              :src="dialogData.data.details.thumbnail"
              alt=""
              :onerror="defaultImg"
            />
          </div>
          <div class="kc r">
            <h3>课程banner:</h3>
            <img
              :src="dialogData.data.details.banner"
              alt=""
              :onerror="defaultImg"
            />
          </div>
          </div>
        </div>
        <div class="introduce">
          <h3>课程目录:</h3>
        </div>
        <div class="introduce">
          <div class="chapter">
            <div class="section">
              <p
                v-for="(item, index) in dialogData.data.chapter"
                :key="item.id"
                :class="index === numC ? 'active' : ''"
                @click="chapter(item, index)"
              >
                {{ item.name }}
              </p>
            </div>
          </div>
          <div class="chapter">
            <div class="section">
              <p
                v-for="(item, index) in sectionData"
                :key="item.id"
                :class="index === numS ? 'active' : ''"
                @click="section(item, index)"
              >
                {{ item.name }}
              </p>
            </div>
          </div>
          <div class="chapter">
            <div class="section">
              <p v-for="item in knowledgeData" :key="item.id">
                {{ item.name }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="dialogData.title == '编辑'">
        <!-- 目录的编辑 -->
        <mlupload
          :CollegesType="CollegesType"
          :dialogData="dialogData"
          @editClick="handleClose"
        ></mlupload>
      </div>
      <div v-else-if="dialogData.title == '编辑试题'">
        <!-- 资源的编辑 -->
<!--        <graphic-->
<!--          v-if="-->
<!--            dialogData.data.details.resource_type == 1 ||-->
<!--            dialogData.data.details.resource_type == 14-->
<!--          "-->
<!--          ref="content"-->
<!--          :CollegesType="CollegesType"-->
<!--          :dialogData="dialogData.data"-->
<!--        ></graphic>-->
<!--        <videoEdit-->
<!--          v-if="-->
<!--            dialogData.data.details.resource_type == 2 ||-->
<!--            dialogData.data.details.resource_type == 13 ||-->
<!--            dialogData.data.details.resource_type == 3 ||-->
<!--            dialogData.data.details.resource_type == 5 ||-->
<!--            dialogData.data.details.resource_type == 6 ||-->
<!--            dialogData.data.details.resource_type == 11 ||-->
<!--            dialogData.data.details.resource_type == 10-->
<!--          "-->
<!--          ref="content"-->
<!--          :dialogData="dialogData.data"-->
<!--        ></videoEdit>-->
<!--        <smallClass-->
<!--          ref="content"-->
<!--          :dialogData="dialogData.data"-->
<!--          :CollegesType="CollegesType"-->
<!--          v-if="-->
<!--            dialogData.data.details.resource_type == 7 ||-->
<!--            dialogData.data.details.resource_type == 8 ||-->
<!--            dialogData.data.details.resource_type == 9 ||-->
<!--            dialogData.data.details.resource_type == 12-->
<!--          "-->
<!--        ></smallClass>-->
        <test
          ref="content"
          v-if="dialogData.data.details.resource_type == 4"
          :dialogData="dialogData.data"
        ></test>
        <resourcesUpload
          ref="resourcesUpload"
          :dialogData="dialogData.data"
        ></resourcesUpload>
      </div>
      <div class="dialog-footer">
        <el-button type="primary" @click="handleClose">返回</el-button>
        <el-button
          type="primary"
          v-if="dialogData.title == '审核'"
          @click="approved('yes')"
          >审核通过</el-button
        >
        <el-button
          type="primary"
          v-if="dialogData.title == '审核'"
          @click="approved('no')"
          >审核不通过</el-button
        >
        <el-button type="primary" v-if="dialogData.edit == true" @click="save"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import aliyun from '@/assets/js/aliyun.js';
// import mlupload from "@/components/upload/mlUpload.vue";
import resourcesUpload from "@/views/testManagement/resourcesUpload.vue";
// import graphic from "@/components/upload/graphic.vue";
import test from "@/views/testManagement/test.vue";
// import videoEdit from "@/components/upload/video.vue";
// import smallClass from "@/components/upload/smallClass.vue";
export default {
  components: {
    // mlupload,
    resourcesUpload,
    // graphic,
    test,
    // videoEdit,
    // smallClass,
  },
  props: ["dialogData", "zylx"], //父组件传值
  computed: {
    //默认展示占位图
    // defaultImg() {
    //   return 'this.src="' + require("@/assets/images/cs.jpg") + '"';
    // },
  },
  data() {
    return {
      // editKc:true,
      //http://iframe.vstrain.cn/train/simulation?url=http://resource.rgzcloud.com/module/WeiKe/wkplayer/&loreid=280&sourceid=36110&token=94e5f37e7f8d0925fe01c61b2d87c73e
      iframUrl: "",
      isIframe: false,
      isWord:false,
      mp4: false,
      mp3: false,
      CollegesType: [], //院校类型数据
      numC: 0,
      numS: 0,
      sectionData: [], //节数据
      knowledgeData: [], //知识点数据
      searchData: {
        resource_type: 0, //资源类型选中的值
        resource_id: "",
        is_public: 0,
        thumbnail: "",
        ico_file_bucket: "",
        file_bucket: "",
        fenbianlv: "",
        file_origin: "",
        file_size: "",
        value_array: [],
      },
    };
  },
  mounted() {
    console.log(666, this.dialogData);
    if (this.dialogData.data.details.file_origin) {
      this.mp4 =
        this.dialogData.data.details.file_origin.indexOf(".mp4") != -1
          ? true
          : false;
    } else {
      this.mp4 = false;
    }

    if (this.dialogData.data.details.file_origin) {
      this.mp3 =
        this.dialogData.data.details.file_origin.indexOf(".mp3") != -1
          ? true
          : false ||this.dialogData.data.details.file_origin.indexOf(".MP3") != -1
          ? true
          : false ;
    } else {
      this.mp3 = false;
    }
    // console.log(this.dialogData.data.details.file_origin,888,this.mp3)

    let typeArr = [5,6, 7, 8, 9, 10, 11, 12];
    // 除了  图文，视频微课，音频，试题，360度全景视频，全景图
    console.log(this.dialogData);

    typeArr.map((item) => {

      if (item == this.dialogData.data.details.resource_type) {
        let token = localStorage.getItem("token");
        let old_lore_id = this.dialogData.data.details.old_lore_id;
        let resource_id = this.dialogData.data.details.id;
        let type = this.dialogData.data.details.resource_type
        // console.log( resource_id,token)
        if(type == 7 || type == 8 || type == 9 || type == 12){
            this.iframUrl = `http://iframe.vstrain.cn/train/simulation?url=http://resource.rgzcloud.com/module/WeiKe/wkplayer/&loreid=${old_lore_id}&sourceid=${resource_id}&token=${token}`;
            this.isIframe = true;
        }else if(type ==6) {
             this.iframUrl=`http://iframe.vstrain.cn/train/getmodeinfo?sourceid=${resource_id}&token=${token}`
             this.isIframe = true;
        }else if(type == 10 || type == 11){
             this.iframUrl=`http://iframe.vstrain.cn/train/bimfaceexamine?sourceid=${resource_id}&token=${token}`
             this.isIframe = true;
        }else if(type == 5 && this.dialogData.edit == false){
            console.log(6666666666666666,this.dialogData)
            this.isWord = true
            //this.iframUrl=this.dialogData.data.details.file_bucket + this.dialogData.data.details.file_origin
            // const data = {
			// 	object: this.$route.query.file,
			// };
			// resource_preview_script(data).then((res) => {
                setTimeout(()=>{
                    preview(this.dialogData.data.details.file_info);
                    console.log(document.querySelector('#previewjiaoben'))
                    document.querySelector('#previewjiaoben').style.height = '100%';
                    document.querySelector('#office-iframe').style.width = '100%';
				document.querySelector('#office-iframe').style.height = '100%';
                },100)
				function preview(previewInfo) {
					const demo = aliyun.config({
						mount: document.querySelector('#previewjiaoben'),
						url: previewInfo.PreviewURL, // 设置文档预览URL地址。,
						wordOptions: {
							isBestScale: true,
						},
						pdfOptions: {
							isInSafeMode: true,
						},
					});
					// 设置AccessToken。
					demo.setToken({
						token: previewInfo.AccessToken,
					});
				}

			// });
        }
      }
    });
    this.init();
  },
  methods: {
    save() {
      this.searchData.resource_type =
        this.dialogData.data.details.resource_type;
      this.searchData.resource_id = this.dialogData.data.details.id;
      let data = this.$refs.resourcesUpload.searchData.zsdName;
      this.searchData.value_array = [];
      if (data.length > 0) {
        data.forEach((element) => {
          let json = {};
          json["node_id"] = element;
          this.searchData.value_array.push(json);
        });
      }
      this.$refs.content.submit();
      let jsons = Object.assign(this.searchData, this.$refs.content.searchData);
      this.$post(this.$api.resourceEdit, jsons).then((res) => {
        if (res.code === 0) {
          this.$message.success("修改成功");
          this.$emit("approvedClick", false);
        }
      });
    },
    //页面消失
    handleClose() {
      this.dialogData.dialogVisible = false;
      this.sectionData = [];
      this.knowledgeData = [];
      this.numC = 0;
      this.numS = 0;
    },
    approved(data) {
      this.$emit("approvedClick", data);
    },
    chapter(item, index) {
      this.sectionData = [];
      this.knowledgeData = [];
      this.numC = index;
      this.$get(this.$api.categoryCoursedetails, { category_id: item.id }).then(
        (res) => {
          if (res.code === 0) {
            this.sectionData = res.ret.chapter;
            this.sectionData.forEach((item, index) => {
              if (index == 0) {
                this.section(item, 0);
              }
            });
          }
        }
      );
    },
    section(item, index) {
      this.numS = index;
      this.$get(this.$api.categoryCoursedetails, { category_id: item.id }).then(
        (res) => {
          if (res.code === 0) {
            this.knowledgeData = res.ret.chapter;
          }
        }
      );
    },
    init() {
      this.$get(this.$api.metaGetorganizationtype).then((res) => {
        if (res.code === 0) {
          this.CollegesType = res.ret;
        }
      });
    },
  },

  watch: {
    dialogData: {
      handler(nerVal) {
        console.log(11111111, this.dialogData);
        if (this.dialogData.data && this.dialogData.data.chapter) {
          this.dialogData.data.chapter.forEach((item, index) => {
            if (index == 0) {
              this.chapter(item, 0);
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style scoped>
.dialog-footer {
  overflow: hidden;
  text-align: center;
}
.diaStyle {
  overflow: hidden;
  padding: 10px 20px;
}
.diaStyle .top {
  display: flex;
}
.imges {
  overflow: hidden;
  width: 200px;
  height: 120px;
}
.imges img {
  width: 200px;
  height: 120px;
}
.title {
  overflow: hidden;
  margin-left: 20px;
}
.title h2 {
  font-size: 20px;
  margin-top: 50px;
  margin-bottom: 10px;
}
.title span {
  line-height: 20px;
  font-size: 12px;
}
.title span em {
  color: #aaa;
  padding-left: 10px;
}
.introduce,
.content {
  overflow: hidden;
  text-align: left;
  margin: 20px 0;
  display: flex;
}
.introduce h3 {
  overflow: hidden;
  padding-right: 20px;
  text-align: left;
  font-size: 16px;
  line-height: 28px;
  min-width: 85px;
}
.introduce p {
  font-size: 14px;
  line-height: 28px;
  text-align: left;
}
.introduce p span {
  padding-right: 10px;
}
.content img {
  width: 100%;
  text-align: center;
}
.content video {
  width: 100%;
  text-align: center;
}

.chapter {
  width: 34%;
  border: 1px solid #d2d1d1;
  margin: 0 8px;
}
.section {
  margin: 8px;
  background: #eaeff5;
  max-height: 280px;
  height: 280px;
  overflow-y: scroll;
}
.section p {
  cursor: pointer;
  line-height: 35px;
  padding: 0 20px;
}
.section p:hover {
  background: #c5e0d1;
}
.section p.active {
  background: #6abc74;
  color: #fff;
}

.introduce .kc {
  width: 400px;
  display: flex;
  flex: 1;
}
.introduce .r {
  display: flex;
  width: 65%;
  flex: 1;
  /*margin-left: 30px;*/
}
.introduce .kc img {
  /*width: 275px;*/
  height: 150px;
}
.introduce .kc.r img {
  /*width: 600px;*/
}
.introduce .kc.r h3 {
  width: 95px;
  display: inline-block;
  /*flex: 1;*/
}
img{
  object-fit: contain;
}
</style>
